import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import PropOwnerSidebar from "../components/propOwner/PropOwnerSidebar";

export default function PropOwnerLayout() {
  const [cssLoaded, setCssLoaded] = useState(false);

  useEffect(() => {
    const links = ["/propOwner/assets/css/styles.css"];
    const scripts = ["/propOwner/assets/js/script.js"];

    let loadedCount = 0;

    links.forEach((href, i) => {
      const link = document.createElement("link");
      link.rel = "stylesheet";
      link.href = href;
      link.setAttribute("data-layout", `propOwner-css-${i}`);

      link.onload = () => {
        loadedCount++;
        if (loadedCount === links.length) setCssLoaded(true);
      };

      // fallback: agar onload fire na ho
      link.onerror = () => {
        loadedCount++;
        if (loadedCount === links.length) setCssLoaded(true);
      };

      document.head.appendChild(link);
    });

    scripts.forEach((src, i) => {
      const script = document.createElement("script");
      script.src = src;
      script.defer = true;
      script.setAttribute("data-layout", `propOwner-js-${i}`);
      document.body.appendChild(script);
    });

    return () => {
      document.querySelectorAll("[data-layout^='propOwner-']").forEach((el) => el.remove());
    };
  }, []);

  if (!cssLoaded) {
    return (
      <div style={{
        position: "fixed",
        inset: 0,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        background: "#f5f6fa",
        zIndex: 9999,
      }}>
        <div style={{
          width: 44,
          height: 44,
          border: "4px solid #e0e0e0",
          borderTop: "4px solid #6c63ff",
          borderRadius: "50%",
          animation: "spin 0.8s linear infinite",
        }} />
        <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
        <p style={{ marginTop: 14, color: "#888", fontSize: 14, fontFamily: "sans-serif" }}>
          Loading...
        </p>
      </div>
    );
  }

  return (
    <div id="app" style={{ display: "block" }}>
      <div className="app">
        <PropOwnerSidebar />
        <Outlet />
      </div>
    </div>
  );
}